// Version : 0.0.1
// Author :AGALYA

/* eslint-disable import/no-anonymous-default-export */
import AuditingToolActionTypes from './auditing-tool.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// AUDITING TOOL LIST
	getAuditingToolListResponse: null,
	getAuditingToolListArr: [],

	// AUDITING TOOL DETAILS
	getAuditingToolDetailsStatus: null,
	getAuditingToolDetailsArr: [],

	// QUESTIONNAIRE
	getQuestionnaireResponse: null,
	getQuestionnaireArr: [],

	// TRAINING PROPOSAL MEMBERS
	getTrainingProposalMembersStatus: null,
	getTrainingProposalMembersArr: [],

	// TRAINING PROPOSAL INDIVIDUAL
	getTrainingProposalIndividualStatus: null,
	getTrainingProposalIndividualArr: [],

	// ADD TRAINING PROPOSAL
	addTrainingProposalStatus: null,

	// UPDATE TRAINING PROPOSAL
	updateTrainingProposalStatus: null,
	// DELETE TRAINING PROPOSAL
	deleteTrainingProposalStatus: null,

	// GET ALL SUPERVISER LIST
	getAllSuperviserListStatus: null,
	getAllSuperviserListArr: [],

	// APPROVE TRAINING PROPOSAL
	approveTrainingProposalStatus: null,

	// SAVE PHYSICAL DOCS
	savePhysicalDocsStatus: null,

	// SAVE DIGITAL DOCS
	saveDigitalDocsStatus: null,

	// RE-AUDIT PROPOSAL
	reAuditProposalStatus: null,

	// GET MEMBER AUDIT ANSWERS
	getMemberAuditAnswersStatus: null,
	getMemberAuditAnswersArr: [],
};
export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET AUDITING TOOL LIST START *********************** */
		case AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_SUCCESS:
			return {
				...state,
				getAuditingToolListResponse: action.payload,
				getAuditingToolListArr: docodeHexResponse(
					action.payload,
					'GetTrainingProposalListKey',
				),
			};

		case AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_FAILURE:
			return {
				...state,
				getAuditingToolListResponse: action.payload,
				getAuditingToolListArr: [],
			};

		case AuditingToolActionTypes.GET_AUDITING_TOOL_LIST_RESPONSE_CHANGED:
			return { ...state, getAuditingToolListResponse: null };
		/** ***************** GET AUDITING TOOL LIST END *********************** */

		/** ***************** FETCH AUDITING TOOL LIST START *********************** */
		case AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_SUCCESS:
			return {
				...state,
				getAuditingToolDetailsStatus: action.payload,
				getAuditingToolDetailsArr: docodeHexResponse(
					action.payload,
					'GetTrainingProposalDetailsKey',
				),
			};
		case AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_FAILURE:
			return {
				...state,
				getAuditingToolDetailsStatus: action.payload,
				getAuditingToolDetailsArr: [],
			};

		case AuditingToolActionTypes.FETCH_AUDITING_TOOL_LIST_CHANGED:
			return { ...state, getAuditingToolDetailsStatus: null };

		/** ***************** FETCH AUDITING TOOL LIST END *********************** */

		/** ***************** GET QUESTIONNAIRE START *********************** */
		case AuditingToolActionTypes.GET_QUESTIONNAIRE_SUCCESS:
			return {
				...state,
				getQuestionnaireResponse: action.payload,
				getQuestionnaireArr: docodeHexResponse(
					action.payload,
					'GetAllQuestionnaireListKey',
				),
			};

		case AuditingToolActionTypes.GET_QUESTIONNAIRE_FAILURE:
			return { ...state, getQuestionnaireResponse: action.payload, getQuestionnaireArr: [] };

		case AuditingToolActionTypes.GET_QUESTIONNAIRE_RESPONSE_CHANGED:
			return { ...state, getQuestionnaireResponse: null };

		/** ***************** GET QUESTIONNAIRE END *********************** */

		/** ***************** GET TRAINING PROPOSAL MEMBERS START *********************** */
		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_SUCCESS:
			return {
				...state,
				getTrainingProposalMembersArr: docodeHexResponse(
					action.payload,
					'GetAllTrainingMembersKey',
				),
				getTrainingProposalMembersStatus: action.payload,
			};

		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_FAILURE:
			return {
				...state,
				getTrainingProposalMembersStatus: action.payload,
				getTrainingProposalMembersArr: [],
			};

		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_MEMBERS_CHANGED:
			return { ...state, getTrainingProposalMembersStatus: null };

		/** ***************** GET TRAINING PROPOSAL MEMBERS END *********************** */

		/** ***************** ADD TRAINING PROPOSAL START *********************** */
		case AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_SUCCESS:
			return {
				...state,
				addTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_FAILURE:
			return {
				...state,
				addTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.ADD_TRAINING_PROPOSAL_CHANGED:
			return { ...state, addTrainingProposalStatus: null };

		/** ***************** ADD TRAINING PROPOSAL END *********************** */

		/** ***************** UPDATE TRAINING PROPOSAL START *********************** */
		case AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_SUCCESS:
			return {
				...state,
				updateTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_FAILURE:
			return {
				...state,
				updateTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.UPDATE_TRAINING_PROPOSAL_CHANGED:
			return { ...state, updateTrainingProposalStatus: null };

		/** ***************** UPDATE TRAINING PROPOSAL END *********************** */

		/** ***************** DELETE TRAINING PROPOSAL START *********************** */
		case AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_SUCCESS:
			return {
				...state,
				deleteTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_FAILURE:
			return {
				...state,
				deleteTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.DELETE_TRAINING_PROPOSAL_CHANGED:
			return { ...state, deleteTrainingProposalStatus: null };

		/** ***************** DELETE TRAINING PROPOSAL END *********************** */

		/** ***************** GET ALL SUPERVISER LIST START *********************** */
		case AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_SUCCESS:
			return {
				...state,
				getAllSuperviserListArr: docodeHexResponse(
					action.payload,
					'GetAllSuperviserListKey',
				),
				getAllSuperviserListStatus: action.payload,
			};

		case AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_FAILURE:
			return {
				...state,
				getAllSuperviserListStatus: action.payload,
				getAllSuperviserListArr: [],
			};

		case AuditingToolActionTypes.GET_ALL_SUPERVISER_LIST_CHANGED:
			return { ...state, getAllSuperviserListStatus: null };

		/** ***************** GET ALL SUPERVISER LIST END *********************** */

		/** ***************** APPROVE TRAINING PROPOSAL START *********************** */
		case AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_SUCCESS:
			return {
				...state,
				approveTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_FAILURE:
			return {
				...state,
				approveTrainingProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.APPROVE_TRAINING_PROPOSAL_CHANGED:
			return { ...state, approveTrainingProposalStatus: null };

		/** ***************** APPROVE TRAINING PROPOSAL END *********************** */

		/** ***************** GET TRAINING PROPOSAL INDIVIDUAL START *********************** */
		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_SUCCESS:
			return {
				...state,
				getTrainingProposalIndividualArr: docodeHexResponse(
					action.payload,
					'GetAllTrainingIndividualKey',
				),
				getTrainingProposalIndividualStatus: action.payload,
			};

		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_FAILURE:
			return {
				...state,
				getTrainingProposalIndividualStatus: action.payload,
				getTrainingProposalIndividualArr: [],
			};

		case AuditingToolActionTypes.GET_TRAINING_PROPOSAL_INDIVIDUAL_CHANGED:
			return { ...state, getTrainingProposalIndividualStatus: null };

		/** ***************** GET TRAINING PROPOSAL INDIVIDUAL END *********************** */

		/** ***************** SAVE PHYSICAL DOCS START *********************** */
		case AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_SUCCESS:
			return {
				...state,
				savePhysicalDocsStatus: action.payload,
			};

		case AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_FAILURE:
			return {
				...state,
				savePhysicalDocsStatus: action.payload,
			};

		case AuditingToolActionTypes.SAVE_PHYSICAL_DOCS_CHANGED:
			return {
				...state,
				savePhysicalDocsStatus: null,
			};

		/** ***************** SAVE PHYSICAL DOCS END *********************** */

		/** ***************** SAVE DIGITAL DOCS START *********************** */
		case AuditingToolActionTypes.SAVE_DIGITAL_DOCS_SUCCESS:
			return {
				...state,
				saveDigitalDocsStatus: action.payload,
			};

		case AuditingToolActionTypes.SAVE_DIGITAL_DOCS_FAILURE:
			return {
				...state,
				saveDigitalDocsStatus: action.payload,
			};

		case AuditingToolActionTypes.SAVE_DIGITAL_DOCS_CHANGED:
			return {
				...state,
				saveDigitalDocsStatus: null,
			};

		/** ***************** SAVE DIGITAL DOCS END *********************** */

		/** ***************** RE-AUDIT PROPOSAL START *********************** */
		case AuditingToolActionTypes.RE_AUDIT_PROPOSAL_SUCCESS:
			return {
				...state,
				reAuditProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.RE_AUDIT_PROPOSAL_FAILURE:
			return {
				...state,
				reAuditProposalStatus: action.payload,
			};

		case AuditingToolActionTypes.RE_AUDIT_PROPOSAL_CHANGED:
			return {
				...state,
				reAuditProposalStatus: null,
			};

		/** ***************** RE-AUDIT PROPOSAL END *********************** */

		/** ***************** GET MEMBER AUDIT ANSWERS START *********************** */
		case AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_SUCCESS:
			return {
				...state,
				getMemberAuditAnswersStatus: action.payload,
				getMemberAuditAnswersArr: docodeHexResponse(
					action.payload,
					'MemberAuditFetchApproveKey',
				),
			};

		case AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_FAILURE:
			return {
				...state,
				getMemberAuditAnswersStatus: action.payload,
				getMemberAuditAnswersArr: [],
			};

		case AuditingToolActionTypes.GET_MEMBER_AUDIT_ANSWERS_CHANGED:
			return {
				...state,
				getMemberAuditAnswersStatus: null,
			};

		/** ***************** GET MEMBER AUDIT ANSWERS END *********************** */

		default:
			return state;
	}
};
